// const DURATION_YEAR = {};

const colors = {
    error1: '#ff0000',
    error2: '#d40000',
    error3: '#a60013',

    warn1: '#ff5400',
    warn2: '#b34800',
    warn3: '#993d00',

    info1: '#0392b7',
    info2: '#05548e',
    info3: '#03385f',

    success1: '#009036',
    success2: '#004b1c',
    success3: '#003714',

    switchoff1: '#b5b5b5',
    switchoff2: '#ababab',
    switchoff3: '#969696',
};

const icons = {
    error: 'status-error.svg',
    warn: 'status-warning.svg',
    info: 'status-info.svg',
    success: 'status-ok.svg',
    switchoff: 'status-switchoff.svg',
};

// in normal order
// const states = {
//     status_1001: {value: "Machine switched off", color: colors.error1, code: 1001},
//     status_1011: {value: "Machine stopped. Pattern code STOP", color: colors.warn3, code: 1011},
//     status_1012: {value: "Machine stopped: Design end", color: colors.warn2, code: 1012},
//     status_1014: {value: "Machine stopped via switching rod", color: colors.warn1, code: 1014},
//     status_1015: {value: "Machine stitches", color: colors.success3, code: 1015},
//     status_1016: {value: "Machine stillstand", color: colors.warn3, code: 1016},
//     status_1017: {value: "Needle changes", color: colors.success2, code: 1017},
//     status_1018: {value: "Cutting thread", color: colors.success1, code: 1018},
//     status_1019: {value: "Pattern ready", color: colors.warn1, code: 1019},
//     status_1020: {value: "Waiting for new pattern", color: colors.warn1, code: 1020},
//     status_1021: {value: "Tablemode available", color: colors.error1, code: 1021},
//     status_1022: {value: "Machine stopped by error", color: colors.error1, code: 1022},
//     status_1023: {value: "Color change", color: colors.warn3, code: 1023},
//     status_1024: {value: "Bobbin case change", color: colors.warn3, code: 1024},
//     status_1025: {value: "Bobbin case magazine change", color: colors.warn3, code: 1025},
//     status_1064: {value: "Main shaft not in upper position", color: colors.error1, code: 1064},
//     status_1066: {value: "Threadbreak", color: colors.warn1, code: 1066},
//     status_1067: {value: "No pressured air", color: colors.error3, code: 1067},
//     status_1068: {value: "No pattern data available", color: colors.warn1, code: 1068},
//     status_1069: {value: "Pailettes not available", color: colors.warn1, code: 1069},
//     status_1070: {value: "Framemargin", color: colors.error2, code: 1070},
//     status_1071: {value: "Power interruption", color: colors.error1, code: 1071},
//     status_1072: {value: "Starting Tablemode", color: colors.success2, code: 1072},
//     status_1073: {value: "Pantograph not back", color: colors.error2, code: 1073},
//     status_1074: {value: "Sequins end position", color: colors.warn3, code: 1074},
//     status_1075: {value: "Drill not available", color: colors.error2, code: 1075},
//     status_1076: {value: "PA-Manual usage is not activated", color: '', code: 1076},
//     status_1077: {value: "Needle blocked", color: colors.error2, code: 1077},
//     status_1078: {value: "Headtype blocked", color: colors.error2, code: 1078},
//     status_1079: {value: "Machine stopped by light barrier", color: colors.warn1, code: 1079},
//     status_1080: {value: "Bobbin case changer: Change needed", color: colors.warn1, code: 1080},
//     status_1081: {value: "State 1081", color: colors.warn1, code: 1081},
// };

const states = {
    status_error:     {value: 'Fehler aufgetreten', translationKey: 'status_error', color: colors.error1, code: 'error'},
    status_warning:   {value: 'Warnmeldungen', translationKey: 'status_warning', color: colors.warn1, code: 'warning'},
    status_info:      {value: 'Betriebsbereit', translationKey: 'status_info', color: colors.info1, code: 'info'},
    status_success:   {value: 'Maschine arbeitet', translationKey: 'status_success', color: colors.success1, code: 'success'},
    status_switchoff: {value: 'Maschine ausgeschaltet', translationKey: 'status_switchoff', color: colors.switchoff3, code: 'switchoff'},

    status_1022: {value: 'Machine Stopped: By Error', translationKey: 'status_1022', color: colors.error1, code: 1022},
    status_1064: {value: 'Main Shaft Not In Upper Position', translationKey: 'status_1064', color: colors.error1, code: 1064},
    status_1066: {value: 'Threadbreak', translationKey: 'status_1066', color: colors.error1, code: 1066},
    status_1067: {value: 'No Pressured Air', translationKey: 'status_1067', color: colors.error3, code: 1067},
    status_1068: {value: 'No Pattern Data Available', translationKey: 'status_1068', color: colors.error3, code: 1068},
    status_1069: {value: 'Pailettes Not Available', translationKey: 'status_1069', color: colors.error3, code: 1069},
    status_1071: {value: 'Power Interruption', translationKey: 'status_1071', color: colors.error1, code: 1071},
    status_1073: {value: 'Pantograph Not Back', translationKey: 'status_1073', color: colors.error2, code: 1073},
    status_1075: {value: 'Drill Not Available', translationKey: 'status_1075', color: colors.error2, code: 1075},
    status_1077: {value: 'Needle Blocked', translationKey: 'status_1077', color: colors.error2, code: 1077},
    status_1078: {value: 'Headtype Blocked', translationKey: 'status_1078', color: colors.error2, code: 1078},
    status_1079: {value: 'Machine Stopped: Light Barrier', translationKey: 'status_1079', color: colors.error1, code: 1079},

    status_1011: {value: 'Machine Stopped: Pattern Code STOP', translationKey: 'status_1011', color: colors.info3, code: 1011},
    status_1012: {value: 'Machine Stopped: Design End', translationKey: 'status_1012', color: colors.info3, code: 1012},
    status_1019: {value: 'Pattern Ready', translationKey: 'status_1019', color: colors.info1, code: 1019},
    status_1020: {value: 'Waiting For New Pattern', translationKey: 'status_1020', color: colors.info2, code: 1020},

    status_1015: {value: 'Machine Stitches', translationKey: 'status_1015', color: colors.success1, code: 1015},
    status_1017: {value: 'Needle Changes', translationKey: 'status_1017', color: colors.success2, code: 1017},
    status_1018: {value: 'Cutting Thread', translationKey: 'status_1018', color: colors.success2, code: 1018},
    status_1072: {value: 'Starting Tablemode', translationKey: 'status_1072', color: colors.success2, code: 1072},

    status_1001: {value: 'Machine Switched Off', translationKey: 'status_1001', color: colors.switchoff1, code: 1001},

    status_1014: {value: 'Machine Stopped: Switching Rod', translationKey: 'status_1014', color: colors.warn1, code: 1014},
    status_1016: {value: 'Machine Stop', translationKey: 'status_1016', color: colors.warn1, code: 1016},
    status_1021: {value: 'Tablemode Available', translationKey: 'status_1021', color: colors.warn3, code: 1021},
    status_1023: {value: 'Color Change', translationKey: 'status_1023', color: colors.warn2, code: 1023},
    status_1024: {value: 'Bobbin Case Change', translationKey: 'status_1024', color: colors.warn2, code: 1024},
    status_1025: {value: 'Bobbin Case Magazine Change', translationKey: 'status_1025', color: colors.warn2, code: 1025},
    status_1070: {value: 'Frame limitation', translationKey: 'status_1070', color: colors.warn3, code: 1070},
    status_1074: {value: 'Sequins End Position', translationKey: 'status_1074', color: colors.warn3, code: 1074},
    status_1076: {value: 'PA-Manual Usage Is Not Activated', translationKey: 'status_1076', color: colors.warn1, code: 1076},
    status_1080: {value: 'Bobbin Case Changer: Change Needed', translationKey: 'status_1080', color: colors.warn2, code: 1080},
    status_1081: {value: 'State 1081', translationKey: 'status_1081', color: colors.warn1, code: 1081},
};

class MachineStates {

    //  Fehler aufgetreten und Stickvorgang unterbrochen! (z.B. Fadenbruch)
    static errorStatusList = [1022, 1064, 1066, 1067, 1068, 1069, 1071, 1073, 1075, 1077, 1078, 1079];

    //  Betriebsbereit, aber etwas muss noch getan werden! (z.B. neues Muster einstellen)
    static infoStatusList = [1011, 1012, 1019, 1020];

    //  Vorgänge die zu den normalen Arbeitsschritten gehören. (z.B. Rahmen wechseln)
    static successStatusList = [1015, 1017, 1018, 1072];

    //  Maschine stickt.
    static stitchesStatusList = [1015];

    //  Maschine wurde ausgeschaltet.
    static switchoffStatusList = [1001];

    //  Warnmeldungen, die zu Fehler führen können. (z.B. Farben wechseln)
    static warningStatusList = [1014, 1016, 1021, 1023, 1024, 1025, 1070, 1074, 1076, 1080, 1081];

    constructor() {

        //this.getColor = this.getColor.bind(this);
        //this.isBlock = this.isBlock.bind(this);
        //this.serialize = this.serialize.bind(this);

    }

    static getStitchStatusList() {

        return MachineStates.stitchesStatusList.concat(MachineStates.warningStatusList);

    }

    static getProductionStatusList() {

        return MachineStates.successStatusList.concat(MachineStates.warningStatusList);

    }

    static getDownStatusList() {

        return MachineStates.errorStatusList.concat(MachineStates.infoStatusList);

    }

    static getTotalStatusList() {

        return MachineStates.errorStatusList.concat(MachineStates.infoStatusList, MachineStates.successStatusList, MachineStates.warningStatusList);

    }

    static getColor(idState) {

        const key = 'status_' + idState;

        if (!states[key]) return colors.error3;

        return states[key];

    }

    static getStates() {

        return states;

    }

    static get(idState) {

        const key = 'status_' + idState;
        const s = states[key];

        return s ? s : null;

    }

    static getLegendPanel() {

        return {
            success: states.status_success,
            info: states.status_info,
            switchoff: states.status_switchoff,
            warning: states.status_warning,
            error: states.status_error,
        };

    }

    static getStatusType(statusCode) {

        statusCode = parseInt(statusCode, 10);

        let statusType = 'warning';

        if (MachineStates.errorStatusList.includes(statusCode)) {
            statusType = 'error';
        } else if (MachineStates.infoStatusList.includes(statusCode)) {
            statusType = 'info';
        } else if (MachineStates.successStatusList.includes(statusCode)) {
            statusType = 'ok';
        } else if (MachineStates.switchoffStatusList.includes(statusCode)) {
            statusType = 'switchoff';
        }

        return statusType;

    }

    static getColorSetByStatus(status) {

        let colorSet = {color1: colors.error1, color2: colors.error2, color3: colors.error3};

        switch (status) {
            case 'info':
                colorSet = {color1: colors.info1, color2: colors.info2, color3: colors.info3};
                break;

            case 'ok':
            case 'success':
                colorSet = {color1: colors.success1, color2: colors.success2, color3: colors.success3};
                break;

            case 'switchoff':
                colorSet = {color1: colors.switchoff1, color2: colors.switchoff2, color3: colors.switchoff3};
                break;

            case 'warning':
                colorSet = {color1: colors.warn1, color2: colors.warn2, color3: colors.warn3};
                break;
        }

        return colorSet;

    }

    static getIconByStatus(status) {

        let icon = icons.error;

        switch (status) {
            case 'info':
                icon = icons.info;
                break;

            case 'ok':
            case 'success':
                icon = icons.success;
                break;

            case 'switchoff':
                icon = icons.switchoff;
                break;

            case 'warning':
                icon = icons.warn;
                break;
        }

        return icon;

    }

    static groupingByStatus(data) {

        if (!data) return null;

        const grouping = {
            error: 0,
            warning: 0,
            info: 0,
            success: 0,
            switchoff: 0,
        };

        for (let status in data) {
            let seconds = data[status];

            if (MachineStates.errorStatusList.includes(parseInt(status))) {
                grouping.error += seconds;
            } else if (MachineStates.infoStatusList.includes(parseInt(status))) {
                grouping.info += seconds;
            } else if (MachineStates.successStatusList.includes(parseInt(status))) {
                grouping.success += seconds;
            } else if (MachineStates.switchoffStatusList.includes(parseInt(status))) {
                grouping.switchoff += seconds;
            } else {
                grouping.warning += seconds;
            }
        }

        return grouping;

    }

    static countPassings(data) {

        return MachineStates.countStatus(data, '1012');

    }

    static countStatus(data, status) {

        if (!data || !status) return 0;

        let counter = 0;

        if (data) {
            data.forEach(
                (sta) => { if (sta.status === status) counter += parseInt(sta.counter); }
            );
        }

        return counter;

    }

    static calculateStitchTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, MachineStates.getStitchStatusList(), unit, fieldName);

    }

    static calculateThreadbreakTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, [1066], unit, fieldName);

    }

    static calculateSetupTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, MachineStates.successStatusList, unit, fieldName, MachineStates.stitchesStatusList);

    }

    static calculateProductionTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, MachineStates.getProductionStatusList(), unit, fieldName);

    }

    static calculateBreakTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, [1016], unit, fieldName);

    }

    static calculateDownTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, MachineStates.getDownStatusList(), unit, fieldName, MachineStates.switchoffStatusList);

    }

    static calculateTotalTime(data, unit = 'ms', fieldName = 'pastTime') {

        return MachineStates.calculateStatusTime(data, MachineStates.getTotalStatusList(), unit, fieldName, MachineStates.switchoffStatusList);

    }

    static calculateStatusTime(data, statusList, unit = 'ms', fieldName = 'pastTime', notAllowedStatus = []) {

        let calculatedTime = 0;

        if (data && fieldName) {
            for (let statusKey in data) {
                let dataRow = data[statusKey];
                let statusCode = parseInt(dataRow.status);

                //if (dataRow[fieldName] && statusList.includes(statusCode) && !notAllowedStatus.includes(statusCode)) calculatedTime += parseInt(dataRow[fieldName]);
                if (dataRow[fieldName] && statusList.includes(statusCode) && !notAllowedStatus.includes(statusCode))
                    calculatedTime += MachineStates.getTimeAfterConversion(parseInt(dataRow[fieldName]), unit);
            }
        }

        return calculatedTime;

    }

    static getTimeAfterConversion(milliseconds, unit = 'ms') {

        let conversionValue = 0;

        switch (unit) {
            case 'h':
                conversionValue = Math.floor(milliseconds / 60 / 60 / 1000);
                break;

            case 'm':
                conversionValue = Math.floor(milliseconds / 60 / 1000);
                break;

            case 's':
                conversionValue = Math.floor(milliseconds / 1000);
                break;

            default:
                conversionValue = milliseconds;
        }

        return conversionValue;

    }

}

export default MachineStates;